module.exports = __webpack_public_path__ + "static/img/1-1.94a3c82.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/1-1.png
// module id = jJDO
// module chunks = 0